import {
  Box,
  Paper,
  Title,
  UnstyledButton,
  createStyles,
  Modal,
  MultiSelect,
  Button,
  Center,
  Loader,
  Select,
  Group,
  Text,
  SimpleGrid,
  Card,
} from "@mantine/core";

import Buttonfilter from "../../assets/img/Icon Button.svg";
import searchIcon from "../../assets/img/searchIcon.svg";
import pverifyIcon from "../../assets/img/pverify-946.png";
import availityIcon from "../../assets/img/availity-2700.png";

import { Pagination } from "@mantine/core";
import { useLocation, useNavigate } from "react-router-dom";
import { forwardRef, useEffect, useState } from "react";
import { useMedplum } from "@medplum/react";
import { showNotification } from "@mantine/notifications";
import { IconPlus, IconStar } from "@tabler/icons-react";
import {
  codingSystemMap,
  CoverageSearchList,
  getPatientName,
  patientSearchList,
} from "./EligibiltyService";
import { circularPlatformLogo } from "../../utils";
import { PatientNotFound } from "../Patient/PatientVisits/DataNotFound";
import { serviceTypeMap } from "./EligibilityDataMap";
import CustomBreadcrumbs from "../../components/CustomBreadCrumbs";
import ProviderCards from "./requestCards";
import { ServiceTag } from "./ServiceTag";

const useStyles = createStyles(() => ({
  default: {
    borderRadius: "8px",
    marginLeft: "40px",
    marginRight: "40px",
    height: "100%",
    padding: "16px",
    marginTop: "16px",
  },
  breadCrumbs: {
    marginBottom: "50px",
    justifyContent: "space-between",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },

  loader: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },

  group: { justifyContent: "space-between", height: "30px", width: "100%" },
  box1: {
    display: "flex",
    flexDirection: "column"
  },
  Boxtitle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
  title: {
    fontWeight: 700,
    fontSize: "26px",
    lineHeight: "36px",
    color: "#262930",
  },
  subTitle: {
    fontWeight: 700,
    fontSize: "22px",
    lineHeight: "36px",
    color: "#262930",
  },
  subTitleBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "center",
  },
  searchBar: {
    display: "flex",
    flexDirection: "row",
    gap: "24px",
    paddingTop: "24px",
    paddingBottom: "16px",
    alignItems: "center",
  },
  tagBox: {
    display: "flex",
    flexDirection: "row",
    gap: "14px",
    borderStyle: "solid",
    borderWidth: "2px",
    borderRadius: '4px',
    borderColor: "#9DCDF3",
    padding: "4px 12px 4px 12px",
    alignItems: "center",
  },
  suppLogoPverify: {
    height: '38px',
    width: '71px',
  },
  suppLogoAvaility: {
    height: '32px',
    width: '80px',
  },
  cardHeading: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "left",
    alignItems: "center",
    width: "100%",
    marginBottom: '16px',
  },
  iconBox: {
    height: '40px',
    width: '40px',
    borderRadius: 5,
    padding: 8,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#53A0DD',
  },
}));

const encodeIDs = (ids: any) => ids.map((id: any) => encodeURIComponent(id));

export const Eligibility = () => {
  const { classes } = useStyles();
  const medplum = useMedplum();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const serviceType = query.get("service") as 'pverify' | 'availity';
  const [currentPage, setCurrentPage] = useState(1);
  const [patientList, setPatientList] = useState<[]>([]);
  const [isCreating, setisCreating] = useState<boolean>(false);
  const [ispatientfetched, setisPateintFetched] = useState<boolean>(false);
  const [total, setTotal] = useState<any>("");
  const [coverageData, setCoverageData] = useState<any>([]);
  const [mappedCResponseList, setMappedCResponseList] = useState<any>([]);
  const [selctedPatient, setselectedPatient] = useState<string>();
  const [searchQuery, setSearcQuery] = useState<string>("");
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filter, setFilter] = useState<any>([]);
  const [totalCERes, setTotalCERes] = useState<any>(0);
    const [searchLoader, setSearchLoader] = useState<boolean>(false);
  const navigate = useNavigate();
  // useEffect(() => {
  //   CoverageEligibilityResponse(1);
  // }, []);

  useEffect(() => {
    coverageSearch(searchQuery);
  }, [searchQuery]);
  useEffect(() => {
    if (selctedPatient) {
      coverageForSelctedPatient(selctedPatient, 1);
    } else {
      CoverageEligibilityResponse(1);
    }
  }, [selctedPatient]);

  useEffect(() => {
    const mappedCoverageData = coverageData.map((cer: any) => {
      return {
        name: cer['Patient Name'],
        providerName: cer.providerName,
        practiceType: cer.practiceType,
        requestId: cer.Eligibility.id,
        backOffice: "EDI",
        status: "Active"
      }
    });

    setMappedCResponseList(mappedCoverageData);
  }, [coverageData]);

  const handlePageChange = (page: number) => {
    if (selctedPatient) {
      coverageForSelctedPatient(selctedPatient, page);
    }
    CoverageEligibilityResponse(page);
    setCurrentPage(page);
  };
  const onSearchChange = (value: any) => {
    setSearcQuery(value);
  };

  const coverageSearch = async (val: any) => {
    setisPateintFetched(true)
    const pateintResponse = await patientSearchList(val, medplum);
    if (pateintResponse?.length == 0) {
      setisPateintFetched(false)
    }


    const patientData = pateintResponse.map((patient: any) => {
      const containsCerner = patient?.identifier?.[0]?.type?.coding?.some(
        (coding: any) => coding.system?.includes("cerner")
      );
      const containsAthena = patient?.identifier?.some(
        (item: any) => item.system && item.system.includes("athena")
      );
      let ehrtype = "";
      if (
        patient?.identifier?.find(
          (id:any) => id.system === "urn:oid:1.2.840.114350.1.13.0.1.7.5.737384.0"
        )
      ) {
        ehrtype = "EPIC";
      } else if (containsCerner) {
        ehrtype = "Cerner";
      } else if (containsAthena) {
        ehrtype = "Athena Health";
      } else {
        ehrtype = "Others";
      }
      let EHRIcon;
      switch (ehrtype) {
        case "EPIC":
          EHRIcon = (
            <img
              src={circularPlatformLogo["epic"]}
              style={{
                marginRight: "10px",
                width: "30px",
              }}
              alt="EPIC"
            />
          );
          break;
        case "Cerner":
          EHRIcon = (
            <img
              src={circularPlatformLogo["cerner"]}
              style={{
                marginRight: "10px",
                width: "30px",
              }}
              alt="Cerner"
            />
          );
          break;
        case "Athena Health":
          EHRIcon = (
            <img
              src={circularPlatformLogo["athenahealth"]}
              style={{
                marginRight: "10px",
                width: "30px",
              }}
              alt="Athena"
            />
          );
          break;
        default:
          EHRIcon = (
            <img
              src={circularPlatformLogo["others"]}
              style={{
                marginRight: "10px",
                width: "30px",
              }}
              alt="Others"
            />
          );
      }
      return {
        label: getPatientName(patient.name),
        value: patient.id,
        ehr: ehrtype,
        icon: EHRIcon,
      };
    });
    setisPateintFetched(false)
    setPatientList(patientData);
  };

  const coverageForSelctedPatient = async (
    selectdID: any,
    pageNumber?: any
  ) => {
    // const res =await CoverageSearchList("123",medplum);
    try {
      setSearchLoader(true);
      setCoverageData([]);
      const count = 20;

      const res = await CoverageSearchList(selectdID, medplum, pageNumber, serviceType);
      const totalpages = Math.ceil((res.bundle.total as any) / 20);
      setTotal(totalpages);

      if (res?.length) {
        const CoverageEligibiltyData = res.map((coverageData: any) => ({
          "Patient Id": coverageData?.patient.reference,
          Id: coverageData?.id,
          Eligibility: coverageData?.outcome,

          request: coverageData?.request?.reference?.split("/")[1],
        }));

        const patientIds = CoverageEligibiltyData.map(
          (data: any) => data["Patient Id"]
        );
        const requestId = CoverageEligibiltyData.map(
          (data: any) => data["request"]
        );

        const urlForPatient = `_count=${count}&_id=${encodeIDs(
          patientIds
        )}&_sort=-_lastUpdated&_total=accurate`;
        const urlForCoverage = `_count=${count}&_id=${encodeIDs(
          requestId
        )}&_sort=-_lastUpdated&_total=accurate`;

        const patientsDataFromId = medplum.searchResources(
          "Patient",
          urlForPatient
        );
        const coverageDatarequestId = medplum.searchResources(
          "CoverageEligibilityRequest",
          urlForCoverage
        );

        const [coverageData, patientData] = await Promise.all([
          coverageDatarequestId,
          patientsDataFromId,
        ]);

        const practiceTypeMap = new Map<string, string>();
        const patientMap = new Map<string, string>();
        const providerMap = new Map<string, string>();

        coverageData.forEach((coverage: any) => {
          const displayName =
            coverage?.item[0]?.category?.coding[0]?.display || "--";
          practiceTypeMap.set(coverage?.id, displayName);
          const providerName = coverage?.provider?.display || "--";
          providerMap.set(coverage?.id, providerName);
        });


        patientData.forEach((patient: any) => {
          const name = getPatientName(patient.name);
          patientMap.set(patient.id, name || "--");
        });

        const updatedCoverageEligibiltyData = CoverageEligibiltyData.map(
          (coverageData: any) => {
            const coverageId = coverageData["request"];
            const Eligibility = coverageData["Eligibility"];
            const patientId = coverageData["Patient Id"]?.split("/")[1];
            const Id = coverageData["Id"];

            const practiceType = practiceTypeMap.get(coverageId || "") || "--";
            const patientName = patientMap.get(patientId || "") || "--";
            const providerName = providerMap.get(coverageId || "") || "--";

            return {
              "Patient Name": patientName,
              practiceType: practiceType,
              providerName: providerName,
              coverageId: coverageId,
              Eligibility: {
                outcome: Eligibility,
                id: Id,
              },
            };
          }
        );
        setCoverageData(updatedCoverageEligibiltyData);
      } else {
        showNotification({
          color: "red",
          message: "No data Found",
          autoClose: true,
        });
      }
    } catch (error) {
      console.error(error);
      showNotification({
        color: "red",
        message: "Failed",
        autoClose: true,
      });
    } finally {
      setSearchLoader(false);
    }
  };
  const handleChange = (value: any) => {
    setselectedPatient(value);
  };

  const CoverageEligibilityResponse = async (PageNumber?: any) => {
    try {
      setisCreating(true);
      setCoverageData([]);
      const count = 20;

      const queryString = `_count=${count}&_offset=${(PageNumber - 1) * count
        }&_sort=-_lastUpdated&_total=accurate&identifier=${codingSystemMap[serviceType]}|`;

        const res = await medplum.searchResources(
        "CoverageEligibilityResponse",
        queryString
      );

      setTotalCERes(res.bundle.total as any);
      const totalpages = Math.ceil((res.bundle.total as any) / 20);
      setTotal(totalpages);

      if (res?.length) {
        const CoverageEligibiltyData = res.map((coverageData: any) => ({
          "Patient Id": coverageData?.patient.reference,
          Id: coverageData?.id,
          Eligibility: coverageData?.outcome,
          request: coverageData?.request?.reference?.split("/")[1],
        }));

        const patientIds = CoverageEligibiltyData.map(
          (data) => data["Patient Id"]
        );
        const requestId = CoverageEligibiltyData.map((data) => data["request"]);

        // const encodeIDs = (ids: any) =>
        //   ids.map((id: any) => encodeURIComponent(id));
        const urlForPatient = `_count=${count}&_id=${encodeIDs(
          patientIds
        )}&_sort=-_lastUpdated&_total=accurate`;
        const urlForCoverage = `_count=${count}&_id=${encodeIDs(
          requestId
        )}&_sort=-_lastUpdated&_total=accurate`;

        const patientsDataFromId = medplum.searchResources(
          "Patient",
          urlForPatient
        );
        const coverageDatarequestId = medplum.searchResources(
          "CoverageEligibilityRequest",
          urlForCoverage
        );

        const [coverageData, patientData] = await Promise.all([
          coverageDatarequestId,
          patientsDataFromId,

        ]);

        const practiceTypeMap = new Map<string, string>();
        const patientMap = new Map<string, string>();
        const providerMap = new Map<string, string>();

        coverageData.forEach((coverage: any) => {
          const displayName =
            coverage?.item[0]?.category?.coding[0]?.display || "--";
          practiceTypeMap.set(coverage?.id, displayName);
          const providerName = coverage?.provider?.display || "--";
          providerMap.set(coverage?.id, providerName);
        });


        patientData.forEach((patient: any) => {
          const name = getPatientName(patient.name);
          patientMap.set(patient.id, name || "--");
        });

        const updatedCoverageEligibiltyData = CoverageEligibiltyData.map(
          (coverageData: any) => {
            const coverageId = coverageData["request"];
            const Eligibility = coverageData["Eligibility"];
            const patientId = coverageData["Patient Id"]?.split("/")[1];
            const Id = coverageData["Id"];

            const practiceType = practiceTypeMap.get(coverageId || "") || "--";
            const patientName = patientMap.get(patientId || "") || "--";
            const providerName = providerMap.get(coverageId || "") || "--";

            return {
              "Patient Name": patientName,
              practiceType: practiceType,
              providerName: providerName,
              coverageId: coverageId,
              Eligibility: {
                outcome: Eligibility,
                id: Id,
              },
            };
          }
        );

        setCoverageData(updatedCoverageEligibiltyData);

      } else {
        showNotification({
          color: "red",
          message: "No data Found",
          autoClose: true,
        });
      }
    } catch (error) {
      console.error(error);
      showNotification({
        color: "red",
        message: "Failed",
        autoClose: true,
      });
    } finally {
      setisCreating(false);
    }
  };

  interface ItemProps extends React.ComponentPropsWithoutRef<"div"> {
    label: string;
    value: any;
    ehr: string;
    icon: any;
  }
  const SelectItem = forwardRef<HTMLDivElement, ItemProps>(
    ({ label, value, ehr, icon, ...others }: ItemProps, ref) => (
      <div ref={ref} {...others}>
        <Group noWrap className={classes.group}>
          <div>
            <Text>{label}</Text>
          </div>
          <div>{icon}</div>
        </Group>
      </div>
    )
  );
  const handleClickDetails = (requestId: any) => {
    navigate(`/admin/insurance/eligibility/details?id=${requestId}`);
  };
  const handleApply = () => {
    const filteredData = coverageData.filter((e: any) => {
      return filter?.includes(e?.practiceType);
    });
    setCoverageData(filteredData);
    setTotal(0)
    setIsFilterModalOpen(false);
  };

  const handleFilterChange = (selectedStatus: any) => {
    CoverageEligibilityResponse(currentPage);

    setFilter(selectedStatus);
  };
  const updatedServiceTypeMap = serviceTypeMap(serviceType).map((item) => ({
    value: item.label,
    label: item.label,
  }));

  return (
    <>
      {" "}
      <Modal
        opened={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        size="md"
        withCloseButton={false}
        closeOnEscape={true}
        closeOnClickOutside={true}
      >
        <Box sx={{ paddingTop: "20px", minHeight: "225px" }}>
          {isCreating ? (
            <Center className={classes.loader}>
              <Loader size="sm" />
            </Center>
          ) : (
            <MultiSelect
              data={updatedServiceTypeMap}
              label="Choose EHR type for filter"
              placeholder="Select filter"
              nothingFound="Nothing found"
              maxDropdownHeight={125}
              dropdownPosition="bottom"
              onChange={handleFilterChange}
              defaultValue={filter}
              clearable={true}
            />
          )}
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            onClick={handleApply}
            disabled={filter.length === 0 ? true : false || isCreating}
          >
            Apply
          </Button>
        </Box>
      </Modal>{" "}
      <Paper className={classes.default}>
        <Box sx={{}}>

          <Box className={classes.box1}>
            <Box className={classes.breadCrumbs}>
              <CustomBreadcrumbs />
              <ServiceTag serviceType={serviceType} />
            </Box>
            {isCreating ? (
              <Center className={classes.loader}>
                <Loader />
              </Center>
            ) : (<> <Box>
              <Box className={classes.Boxtitle} mb={24}>
                <Title className={classes.title}>Eligibility</Title>
                <Box>
                  <Button
                    onClick={() => {
                      navigate("new?service=" + serviceType);
                    }}
                    sx={{ backgroundColor: "#1B75BC", width: "130px" }}
                  >
                    <IconPlus size={'20px'} style={{ marginRight: "6px" }} /> Add New
                  </Button>
                </Box>

              </Box>
              <SimpleGrid cols={3} spacing={24} >
                <Card padding="lg" radius="md" withBorder  >
                  <Box className={classes.cardHeading}>
                    <Box className={classes.iconBox} mr={12}><IconStar size={'22px'} color="#53A0DD"></IconStar></Box>
                    Total Request
                  </Box>
                  <Text weight={600} ml={68} sx={{ fontSize: "28px" }}>{totalCERes}</Text>
                </Card>
                <Card padding="lg" radius="md" withBorder  >
                  <Box className={classes.cardHeading}>
                    <Box className={classes.iconBox} mr={12}><IconStar size={'22px'} color="#53A0DD"></IconStar></Box>
                    Active Coverages
                  </Box>
                  <Text weight={600} ml={68} sx={{ fontSize: "28px" }}>{totalCERes}</Text>
                </Card>
                <Card padding="lg" radius="md" withBorder  >
                  <Box className={classes.cardHeading}>
                    <Box className={classes.iconBox} mr={12}><IconStar size={'22px'} color="#53A0DD"></IconStar></Box>
                    Back-Office
                  </Box>
                  <Text weight={600} ml={68} sx={{ fontSize: "28px" }}>{0}</Text>
                </Card>
              </SimpleGrid>


              {/* searchbar */}
              <Box className={classes.subTitleBox}>
                <Title className={classes.subTitle}>Requests</Title>
                <Box className={classes.searchBar}>

                  <Box>
                    <UnstyledButton
                      onClick={() => {
                        setIsFilterModalOpen(true);
                      }}
                    >
                      <Box>
                        <img src={Buttonfilter} />
                      </Box>
                    </UnstyledButton>
                  </Box>
                  <Box sx={{ maxWidth: "438px" }}>
                    <Select
                      // label="Select patient"
                      icon={<img src={searchIcon} />}
                      placeholder="Search by keyword"
                      required={true}
                      data={patientList}
                      rightSection={
                        ispatientfetched ? <Loader size={"sm"} /> : ""
                      }
                      // mt="lg"
                      size="lg"
                      radius="md"
                      clearable={true}
                      onChange={handleChange}
                      sx={{
                        ".mantine-Select-itemsWrapper": {
                          paddingRight: "10px",
                        },
                      }}
                      searchable
                      onSearchChange={onSearchChange}
                      searchValue={searchQuery}
                      itemComponent={SelectItem}
                    />
                  </Box>

                </Box>
              </Box>
            </Box>

              {searchLoader
                ? (<Center className={classes.loader} top={'80%'}>
                  <Loader />
                </Center>)
                : (<Box>

                  <Box pb={16}>
                    {coverageData.length === 0 ? (
                      <Center pt={60}>
                        <PatientNotFound patient={"Eligibility Data"} />
                      </Center>
                    ) : (
                      <>
                        <ProviderCards providers={mappedCResponseList} handleDetails={handleClickDetails} />
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginTop: "18px",
                          }}
                        >
                          <Pagination
                            total={total}
                            onChange={handlePageChange}
                            defaultValue={currentPage}
                          />
                        </Box>
                      </>
                    )}
                  </Box>

                </Box>)}
            </>)}
          </Box>
        </Box>
      </Paper>
    </>
  );
};


